import createPersistedState from "vuex-persistedstate";

export default ({ store }) => {
  createPersistedState({
    key: "vuex",
    paths: [
      // removed persisted state for menu bulk upload for bringing in default browser popup and confirmation popup
      // "menu.menuUploadRawData",
      // "menu.menuUploadList",
      // "menu.menuUploadInvalidList",
      // "menu.menuUploadFieldMap",
      // "menu.menuUploadCurrentStep",
      // "menu.menuUploadInvalidList",
      // "menu.menuUploadDuplicateList",
      // "menu.menuUploadMissingNameList",
      "menu.menuUploadExceededCharLimitList",
      "report.selectedTimeRange",
      "report.selectedRangeInterval",
      "report.selectedStartDate",
      "report.selectedEndDate",
      "report.selectedOrderFilter"
    ]
  })(store);
};
